import React from "react";
import ButtonProject from "../assets/buttonproject.svg";

export const Come_on = () => {
  const handleClick = () => {
    const url = `https://wa.me/${"5588981849258"}?text=${encodeURIComponent(
      "Olá Kauê me chamo: "
    )}`;
    window.location.href = url;
  };

  return (
    <div className="tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-6">
      <div className="tw-max-w-[750px]">
        <p className="tw-font-bold tw-text-5xl tw-text-center tw-text-[#D0E8F4]">
          "Transforme suas ideias em realidade e impulsione o sucesso do seu
          negócio”.
        </p>
      </div>
      <div className="tw-max-w-[750px]">
        <p className="tw-font-normal tw-indent-1 tw-text-base tw-text-[#94ABBD] tw-text-center tw-my-6">
          Explore meu portfólio repleto de soluções inovadoras e entre em
          contato hoje mesmo. Vamos transformar suas ideias em realidade e
          impulsionar o sucesso do seu negócio!"
        </p>
      </div>
      <button onClick={handleClick} className="tw-px-5 tw-py-3 tw-bg-[#D0E8F4] tw-rounded-3xl tw-text-[#111827] tw-font-bold">Venha construir seu sucesso</button>
    </div>
  );
};
